module.exports = __webpack_public_path__ + "static/media/iconYouTube.194f6450.svg";